// src/components/ChunkErrorBoundary.jsx
// Catches render errors under a Suspense region so a failed lazy chunk (or any
// other crash) shows a small panel instead of unmounting the whole app.
import React from "react";
import { isChunkLoadError } from "../lib/lazyWithRetry";

export default class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ChunkErrorBoundary caught:", error, info?.componentStack);
  }

  componentDidUpdate(prevProps) {
    // Navigating elsewhere (new resetKey) clears a previous error.
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    if (this.props.silent) return null;
    const chunk = isChunkLoadError(error);
    return (
      <div
        role="alert"
        style={{
          margin: "24px auto",
          maxWidth: 420,
          padding: "16px 20px",
          border: "1px solid #e5e7eb",
          borderRadius: 8,
          background: "#fff",
          color: "#111827",
          textAlign: "center",
          fontSize: 14,
          boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
        }}
      >
        <div style={{ fontWeight: 600, marginBottom: 6 }}>
          {chunk ? "A new version of the app is available." : "Something went wrong."}
        </div>
        <div style={{ color: "#6b7280", marginBottom: 12 }}>
          {chunk ? "Reload to get the latest version." : "Reload the page to try again."}
        </div>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            padding: "6px 16px",
            borderRadius: 6,
            border: "1px solid #2563eb",
            background: "#2563eb",
            color: "#fff",
            cursor: "pointer",
            fontSize: 14,
          }}
        >
          Reload
        </button>
      </div>
    );
  }
}
